import { render } from "./BasePaginationBottomBar.vue?vue&type=template&id=3be7bc66&scoped=true"
import script from "./BasePaginationBottomBar.vue?vue&type=script&lang=ts"
export * from "./BasePaginationBottomBar.vue?vue&type=script&lang=ts"

import "./BasePaginationBottomBar.vue?vue&type=style&index=0&id=3be7bc66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3be7bc66"

export default script